import { AttemptedActionKey } from 'constants/attempted';
import { AnyAuthenticatedUserAction } from 'types';

const setAttemptedAction = (attemptedAction: AnyAuthenticatedUserAction) => {
    window.sessionStorage.setItem(
        AttemptedActionKey,
        JSON.stringify(attemptedAction),
    );
};

const removeAttemptedAction = () => {
    window.sessionStorage.removeItem(AttemptedActionKey);
};

const getAttemptedAction = (): AnyAuthenticatedUserAction | undefined => {
    const storedAttemptedAction =
        window.sessionStorage.getItem(AttemptedActionKey);
    const attemptedAction = storedAttemptedAction
        ? JSON.parse(storedAttemptedAction)
        : undefined;

    return attemptedAction;
};

const getAndRemoveAttemptedAction = ():
    | AnyAuthenticatedUserAction
    | undefined => {
    const attemptedAction = getAttemptedAction();

    removeAttemptedAction();

    return attemptedAction;
};

export const attemptedActionStore = {
    set: setAttemptedAction,
    remove: removeAttemptedAction,
    get: getAttemptedAction,
    getAndRemove: getAndRemoveAttemptedAction,
};
